'use client';

import React, { createContext, useContext } from 'react';

export interface AgreementItem {
  id: number;
  title: string;
  slug: string;
  content?: string;
  is_required: boolean;
}

export interface FormAgreements {
  required: AgreementItem[];
  optional: AgreementItem[];
}

export interface NewsletterFormDetails {
  id: number;
  title: string;
  slug: string;
  language?: { id?: number; name?: string; code?: string };
  agreements: FormAgreements;
  fields?: Array<{
    type?: string;
    name?: string;
    field?: string;
    label?: string;
    title?: string;
    placeholder?: string;
    required?: boolean | string | number;
  }>;
}

export interface NewsletterFormDataContextValue {
  formDetails: NewsletterFormDetails | null;
  loading: boolean;
  error: string | null;
}

const NewsletterFormDataContext = createContext<NewsletterFormDataContextValue | undefined>(undefined);

export interface NewsletterFormDataProviderProps {
  children: React.ReactNode;
  initialFormDetails: NewsletterFormDetails | null;
}

/**
 * Layout'ta bir kez alınan e-bülten form detayı; RedCta her sayfada /api/forms/details çağırmaz.
 */
export function NewsletterFormDataProvider({ children, initialFormDetails }: NewsletterFormDataProviderProps) {
  const value: NewsletterFormDataContextValue = {
    formDetails: initialFormDetails ?? null,
    loading: false,
    error: null,
  };
  return (
    <NewsletterFormDataContext.Provider value={value}>
      {children}
    </NewsletterFormDataContext.Provider>
  );
}

export function useNewsletterFormData(): NewsletterFormDataContextValue {
  const ctx = useContext(NewsletterFormDataContext);
  if (ctx === undefined) {
    return { formDetails: null, loading: false, error: null };
  }
  return ctx;
}
